
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelBoard as ObiBuoyBarrelBoardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-board.js';
 
 
 

 
 export const ObiBuoyBarrelBoard = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-board',
   elementClass: ObiBuoyBarrelBoardElement,
   events: {
     
   }
  });
 
 